import { Route, Switch, useRouteMatch } from 'react-router-dom';

import Classroom from '../../pages/Classroom';
import { ClassroomRoster } from '../../pages/ClassroomRoster';
import { SelectDeepLink } from '../../pages/SelectDeepLink';

export interface LtiRoutesParams {
    classUuid: string;
    recordingUuid?: string;
    classSessionUuid?: string;
}

const ClassroomRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={`${path}/:classUuid`} component={Classroom} />
            <Route exact path={`${path}/:classUuid/session/:classSessionUuid`} component={Classroom} />
            <Route exact path={`${path}/:classUuid/roster`} component={ClassroomRoster} />
            <Route path={`${path}/:classUuid/recording/:recordingUuid/:action`} component={Classroom} />
            <Route path={`${path}/:classUuid/select-deep-link`} component={SelectDeepLink} />
        </Switch>
    );
};

export default ClassroomRoutes;
